import { render, staticRenderFns } from "./ComponentSkeleton.vue?vue&type=template&id=1aad77de&scoped=true"
var script = {}
import style0 from "./ComponentSkeleton.vue?vue&type=style&index=0&id=1aad77de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aad77de",
  null
  
)

export default component.exports